import React from 'react';
import MapComponent from './MapComponent';

function App() {
  return (
    <div className="App">
      <MapComponent />
    </div>
  );
}

export default App;
